export function useIsPageCitySpecific() {
  const isPageCitySpecific =
    window.location.pathname.includes('/cities/') ||
    window.location.pathname.includes('/events/') ||
    window.location.pathname.includes('/checkout/');

  return { isPageCitySpecific };
}
